module.exports = __webpack_public_path__ + "static/media/allGlass.f2969183.jpg";